import React from "react";
import { Category } from "../types/ProductType";

type CategoryBannerProps = {
  category: Category;
  height?: string;
  className?: string;
};

export const CategoryBanner: React.FC<CategoryBannerProps> = ({
  category,
  height = "h-64",
  className = "",
}) => {
  // Determine which image to use: banner_path > image_path > gradient
  const imageUrl = category.banner_path || category.image_path;

  return (
    <div className={`relative ${height} w-full overflow-hidden rounded-lg shadow-lg ${className}`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={category.name}
          className="h-full w-full object-cover"
          onError={(e) => {
            // Fallback to gradient if image fails to load
            const target = e.target as HTMLImageElement;
            target.style.display = "none";
            const parent = target.parentElement;
            if (parent) {
              const gradientDiv = parent.querySelector(".gradient-fallback");
              if (gradientDiv) {
                (gradientDiv as HTMLElement).style.display = "flex";
              }
            }
          }}
        />
      ) : null}
      {/* Gradient fallback */}
      <div
        className={`gradient-fallback h-full w-full bg-gradient-to-br from-lime-300 via-emerald-300 to-green-400 flex items-center justify-center ${
          imageUrl ? "hidden" : "flex"
        }`}
      >
        <div className="text-center text-white px-8">
          <h1 className="text-white text-4xl md:text-5xl font-bold mb-4">
            {category.name}
          </h1>
          {category.meta_description && (
            <p className="text-lg opacity-90 max-w-2xl mx-auto">
              {category.meta_description.length > 150
                ? `${category.meta_description.substring(0, 150)}...`
                : category.meta_description}
            </p>
          )}
        </div>
      </div>
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
      {/* Category info overlay */}
      <div className="absolute inset-0 flex items-center">
        <div className="container mx-auto px-6">
          {category.meta_description && (
            <p className="text-white/90 text-lg max-w-2xl">
              {category.meta_description.length > 200
                ? `${category.meta_description.substring(0, 200)}...`
                : category.meta_description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

